module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-home inner-page"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', {
    staticClass: "inner-page-wrap"
  }, [_c('Header'), _c('div', {
    staticClass: "homebanner_section"
  }, [(_vm.props.acf.home_banner_src_url) ? _c('video', {
    staticClass: "hero-homevideo",
    attrs: {
      "autoplay": "autoplay",
      "loop": "loop",
      "poster": _vm.props.acf.home_banner_poster,
      "preload": "preload",
      "muted": "true"
    },
    domProps: {
      "muted": true
    }
  }, [(_vm.props.acf.home_banner_src_url) ? _c('source', {
    attrs: {
      "src": _vm.props.acf.home_banner_src_url,
      "type": "video/mp4"
    }
  }) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "hero-homeoverlay"
  }), _c('div', {
    staticClass: "hero-homecontentwrap"
  }, [(_vm.props.acf.home_banner_caption_title) ? _c('h1', {
    staticClass: "hero-homeslogan",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_banner_caption_title)
    }
  }) : _vm._e(), (_vm.props.acf.home_banner_btn_url) ? _c('router-link', {
    staticClass: "hero-homecta",
    attrs: {
      "to": _vm.props.acf.home_banner_btn_url
    }
  }, [(_vm.props.acf.home_banner_btn_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_banner_btn_text)
    }
  }) : _vm._e()]) : _vm._e()], 1)]), _c('div', {
    staticClass: "homephilosophy_section"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.philosphy_section_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_section_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "homephilosophy-banner"
  }, [_c('span', {
    staticClass: "clickbtn",
    on: {
      "click": function($event) {
        return _vm.ourPromise()
      }
    }
  }, [(_vm.props.acf.philosphy_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.philosphy_img,
      "alt": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "homephilosophy-overlay"
  }), _c('div', {
    staticClass: "homephilosophy-content"
  }, [(_vm.props.acf.philosphy_content_title) ? _c('div', {
    staticClass: "homephilosophy-content-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_content_title)
    }
  }) : _vm._e(), (_vm.props.acf.philosphy_content_learn_more) ? _c('div', {
    staticClass: "homephilosophy-content-button",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_content_learn_more)
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "philosphy_thumb_outer clearfix"
  }, [_c('div', {
    staticClass: "philosphy_thumb"
  }, [_c('span', {
    staticClass: "thumb-philosophy clickbtn",
    on: {
      "click": function($event) {
        return _vm.setsApart1()
      }
    }
  }, [(_vm.props.acf.philosphy_thumb_1_img) ? _c('div', {
    staticClass: "thumb-philosophy_bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.philosphy_thumb_1_img + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "thumb-philosophy_overlay"
  }), _c('div', {
    staticClass: "thumb-philosophy_gradient"
  }), _c('div', {
    staticClass: "thumb-philosophy_content-container"
  }, [(_vm.props.acf.philosphy_thumb_1_title) ? _c('div', {
    staticClass: "thumb-philosophy_label",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_1_title)
    }
  }) : _vm._e(), (_vm.props.acf.philosphy_thumb_1_learn_more) ? _c('div', {
    staticClass: "thumb-philosophy_learn-more",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_1_learn_more)
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "philosphy_thumb"
  }, [_c('span', {
    staticClass: "thumb-philosophy clickbtn",
    on: {
      "click": function($event) {
        return _vm.setsApart1()
      }
    }
  }, [(_vm.props.acf.philosphy_thumb_2_img) ? _c('div', {
    staticClass: "thumb-philosophy_bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.philosphy_thumb_2_img + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "thumb-philosophy_overlay"
  }), _c('div', {
    staticClass: "thumb-philosophy_gradient"
  }), _c('div', {
    staticClass: "thumb-philosophy_content-container"
  }, [(_vm.props.acf.philosphy_thumb_2_title) ? _c('div', {
    staticClass: "thumb-philosophy_label",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_2_title)
    }
  }) : _vm._e(), (_vm.props.acf.philosphy_thumb_2_learn_more) ? _c('div', {
    staticClass: "thumb-philosophy_learn-more",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_2_learn_more)
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "philosphy_thumb"
  }, [_c('span', {
    staticClass: "thumb-philosophy clickbtn",
    on: {
      "click": function($event) {
        return _vm.setsApart1()
      }
    }
  }, [(_vm.props.acf.philosphy_thumb_3_img) ? _c('div', {
    staticClass: "thumb-philosophy_bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.philosphy_thumb_3_img + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "thumb-philosophy_overlay"
  }), _c('div', {
    staticClass: "thumb-philosophy_gradient"
  }), _c('div', {
    staticClass: "thumb-philosophy_content-container"
  }, [(_vm.props.acf.philosphy_thumb_3_title) ? _c('div', {
    staticClass: "thumb-philosophy_label",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_3_title)
    }
  }) : _vm._e(), (_vm.props.acf.philosphy_thumb_3_learn_more) ? _c('div', {
    staticClass: "thumb-philosophy_learn-more",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_3_learn_more)
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "philosphy_thumb"
  }, [_c('span', {
    staticClass: "thumb-philosophy clickbtn",
    on: {
      "click": function($event) {
        return _vm.setsApart1()
      }
    }
  }, [(_vm.props.acf.philosphy_thumb_4_img) ? _c('div', {
    staticClass: "thumb-philosophy_bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.philosphy_thumb_4_img + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "thumb-philosophy_overlay"
  }), _c('div', {
    staticClass: "thumb-philosophy_gradient"
  }), _c('div', {
    staticClass: "thumb-philosophy_content-container"
  }, [(_vm.props.acf.philosphy_thumb_4_title) ? _c('div', {
    staticClass: "thumb-philosophy_label",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_4_title)
    }
  }) : _vm._e(), (_vm.props.acf.philosphy_thumb_4_learn_more) ? _c('div', {
    staticClass: "thumb-philosophy_learn-more",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_4_learn_more)
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "philosphy_thumb"
  }, [_c('span', {
    staticClass: "thumb-philosophy clickbtn",
    on: {
      "click": function($event) {
        return _vm.setsApart1()
      }
    }
  }, [(_vm.props.acf.philosphy_thumb_5_img) ? _c('div', {
    staticClass: "thumb-philosophy_bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.philosphy_thumb_5_img + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "thumb-philosophy_overlay"
  }), _c('div', {
    staticClass: "thumb-philosophy_gradient"
  }), _c('div', {
    staticClass: "thumb-philosophy_content-container"
  }, [(_vm.props.acf.philosphy_thumb_5_title) ? _c('div', {
    staticClass: "thumb-philosophy_label",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_5_title)
    }
  }) : _vm._e(), (_vm.props.acf.philosphy_thumb_5_learn_more) ? _c('div', {
    staticClass: "thumb-philosophy_learn-more",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_5_learn_more)
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "philosphy_thumb"
  }, [_c('span', {
    staticClass: "thumb-philosophy clickbtn",
    on: {
      "click": function($event) {
        return _vm.setsApart1()
      }
    }
  }, [(_vm.props.acf.philosphy_thumb_6_img) ? _c('div', {
    staticClass: "thumb-philosophy_bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.philosphy_thumb_6_img + ')'
    })
  }) : _vm._e(), _c('div', {
    staticClass: "thumb-philosophy_overlay"
  }), _c('div', {
    staticClass: "thumb-philosophy_gradient"
  }), _c('div', {
    staticClass: "thumb-philosophy_content-container"
  }, [(_vm.props.acf.philosphy_thumb_6_title) ? _c('div', {
    staticClass: "thumb-philosophy_label",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_6_title)
    }
  }) : _vm._e(), (_vm.props.acf.philosphy_thumb_6_learn_more) ? _c('div', {
    staticClass: "thumb-philosophy_learn-more",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_thumb_6_learn_more)
    }
  }) : _vm._e()])])])])])]), _c('div', {
    staticClass: "homephilosophyvideo_section",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.philosphy_video_bg_img + ')'
    })
  }, [(_vm.props.acf.philosphy_video_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.philosphy_video_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "custom-home-video-container"
  }, [_c('div', {
    staticClass: "custom-home-video"
  }, [(_vm.props.acf.philosphy_video_src) ? _c('video', {
    attrs: {
      "controls": "controls",
      "poster": _vm.props.acf.philosphy_video_thumb,
      "preload": "preload"
    }
  }, [(_vm.props.acf.philosphy_video_src) ? _c('source', {
    attrs: {
      "src": _vm.props.acf.philosphy_video_src,
      "type": "video/mp4"
    }
  }) : _vm._e()]) : _vm._e()])])]), _c('div', {
    staticClass: "homepatient_section"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('div', {
    staticClass: "homepatient_wrap clearfix"
  }, [_c('div', {
    staticClass: "homepatient_left"
  }, [(_vm.props.acf.home_new_patient_img_1) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.home_new_patient_img_1,
      "alt": ""
    }
  }) : _vm._e(), (_vm.props.acf.home_new_patient_img_2) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.home_new_patient_img_2,
      "alt": ""
    }
  }) : _vm._e(), (_vm.props.acf.home_new_patient_img_3) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.home_new_patient_img_3,
      "alt": ""
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "homepatient_right"
  }, [(_vm.props.acf.home_new_patient_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_new_patient_title)
    }
  }) : _vm._e(), (_vm.props.acf.home_new_patient_content) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_new_patient_content)
    }
  }) : _vm._e(), (_vm.props.acf.home_new_patient_btn_1_url) ? _c('router-link', {
    staticClass: "new-patient_button",
    attrs: {
      "to": _vm.props.acf.home_new_patient_btn_1_url
    }
  }, [(_vm.props.acf.home_new_patient_btn_1_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_new_patient_btn_1_text)
    }
  }) : _vm._e()]) : _vm._e(), (_vm.props.acf.home_new_patient_btn_2_url) ? _c('router-link', {
    staticClass: "new-patient_button",
    attrs: {
      "to": _vm.props.acf.home_new_patient_btn_2_url
    }
  }, [(_vm.props.acf.home_new_patient_btn_2_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_new_patient_btn_2_text)
    }
  }) : _vm._e()]) : _vm._e()], 1)])])]), _c('div', {
    staticClass: "testimonialvideo_section"
  }, [(_vm.props.acf.home_testimonial_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.home_testimonial_title)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "custom-home-video-container"
  }, [_c('div', {
    staticClass: "custom-home-video"
  }, [(_vm.props.acf.home_testimonial_src) ? _c('video', {
    attrs: {
      "controls": "controls",
      "poster": _vm.props.acf.home_testimonial_video_poster,
      "preload": "preload"
    }
  }, [(_vm.props.acf.home_testimonial_src) ? _c('source', {
    attrs: {
      "src": _vm.props.acf.home_testimonial_src,
      "type": "video/mp4"
    }
  }) : _vm._e()]) : _vm._e()])])]), _c('div', {
    staticClass: "homegrid_section"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('div', {
    staticClass: "homegrid1 clearfix"
  }, [_c('span', {
    staticClass: "grid1inner clickbtn",
    on: {
      "click": function($event) {
        return _vm.aboutDoctor()
      }
    }
  }, [_c('div', {
    staticClass: "homegrid1left"
  }, [(_vm.props.acf.grid_1_img) ? _c('img', {
    attrs: {
      "src": _vm.props.acf.grid_1_img,
      "alt": ""
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "homegrid1right"
  }, [(_vm.props.acf.grid_1_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.grid_1_title)
    }
  }) : _vm._e(), (_vm.props.acf.grid_1_content) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.grid_1_content)
    }
  }) : _vm._e(), (_vm.props.acf.learn_more_btn) ? _c('div', {
    staticClass: "grid_btn",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.learn_more_btn)
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "homegrid2"
  }, [_c('span', {
    staticClass: "grid2_inner clickbtn",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.grid_2_img + ')'
    }),
    on: {
      "click": function($event) {
        return _vm.aboutDoctorTreatment()
      }
    }
  }, [_c('div', {
    staticClass: "grid_overlaygradient"
  }), _c('div', {
    staticClass: "grid_overlay"
  }), _c('div', {
    staticClass: "grid_hovercontent"
  }, [(_vm.props.acf.grid_2_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.grid_2_title)
    }
  }) : _vm._e(), (_vm.props.acf.grid_2_content) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.grid_2_content)
    }
  }) : _vm._e(), (_vm.props.acf.learn_more_btn_2) ? _c('div', {
    staticClass: "grid2btn",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.learn_more_btn_2)
    }
  }) : _vm._e(), _c('p')])]), _c('div', {
    staticClass: "aftergrid2_content"
  }, [_c('div', {
    staticClass: "aftergrid2_inner"
  }, [(_vm.props.acf.grid_2_content_after_content) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.grid_2_content_after_content)
    }
  }) : _vm._e()])])]), _c('div', {
    staticClass: "homegrid2 grid3"
  }, [_c('span', {
    staticClass: "grid2_inner clickbtn",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.grid_3_img + ')'
    }),
    on: {
      "click": function($event) {
        return _vm.aboutDoctorage7()
      }
    }
  }, [_c('div', {
    staticClass: "grid_overlaygradient"
  }), _c('div', {
    staticClass: "grid_overlay"
  }), _c('div', {
    staticClass: "grid_hovercontent"
  }, [(_vm.props.acf.grid_3_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.grid_3_title)
    }
  }) : _vm._e(), (_vm.props.acf.grid_3_content) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.grid_3_content)
    }
  }) : _vm._e(), (_vm.props.acf.learn_more_btn_3) ? _c('div', {
    staticClass: "grid2btn",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.learn_more_btn_3)
    }
  }) : _vm._e(), _c('p')])])]), _c('div', {
    staticClass: "homegrid1 grid4 clearfix"
  }, [(_vm.props.acf.grid_4_btn_url) ? _c('router-link', {
    staticClass: "grid1inner clearfix",
    attrs: {
      "to": _vm.props.acf.grid_4_btn_url
    }
  }, [_c('div', {
    staticClass: "homegrid1left",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.grid_4_img + ')'
    })
  }), _c('div', {
    staticClass: "homegrid1right"
  }, [(_vm.props.acf.grid_4_title) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.grid_4_title)
    }
  }) : _vm._e(), (_vm.props.acf.grid_4_content) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.grid_4_content)
    }
  }) : _vm._e(), (_vm.props.acf.learn_more_btn_4) ? _c('div', {
    staticClass: "grid_btn",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.learn_more_btn_4)
    }
  }) : _vm._e()])]) : _vm._e()], 1)])]), _c('div', {
    staticClass: "homesmilegallery_section"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.smile_gallery_list) ? _c('div', {
    staticClass: "homesmilegalleryouter clearfix"
  }, [_c('swiper', {
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOptionhome
    }
  }, [_vm._l((_vm.props.acf.smile_gallery_list), function(SmilesliderList, k) {
    return _c('swiper-slide', [_c('span', {
      staticClass: "clickbtn",
      on: {
        "click": function($event) {
          return _vm.aboutSmilegallery()
        }
      }
    }, [(SmilesliderList.url) ? _c('img', {
      attrs: {
        "src": SmilesliderList.url,
        "alt": ""
      }
    }) : _vm._e()])])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e()])]), _c('div', {
    staticClass: "homecta_section"
  }, [_c('div', {
    staticClass: "manual_container"
  }, [_c('h5', [_vm._v("Helping people smile in")]), _c('ul', {
    staticClass: "location_list"
  }, [_c('li', [_c('span', {
    staticClass: "clickbtn",
    on: {
      "click": function($event) {
        return _vm.aboutLocation0()
      }
    }
  }, [(_vm.props.acf.location_1_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.location_1_text)
    }
  }) : _vm._e(), (_vm.props.acf.location_5_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.location_5_text)
    }
  }) : _vm._e()])])]), (_vm.props.acf.cta_btn_url) ? _c('router-link', {
    staticClass: "cta_btn",
    attrs: {
      "to": _vm.props.acf.cta_btn_url
    }
  }, [(_vm.props.acf.cta_btn_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.cta_btn_text)
    }
  }) : _vm._e()]) : _vm._e()], 1)]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d269366","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 520
// module chunks = 1